export default "__VITE_ASSET__BQihjSVo__"